import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SelfOnboardingCreateAccountPage } from '../self-onboarding-create-account-page';
import { SelfOnboardingVerifyAccountPage } from '../self-onboarding-verify-account-page';

const routes: Routes = [
  {
    path: '',
    component: SelfOnboardingCreateAccountPage
  },
  {
    path: 'verify',
    component: SelfOnboardingVerifyAccountPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SelfOnboardingModule {}
